import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navigation } from "./components/Navigation";
import { FloatingCallButton } from "./components/FloatingCallButton";
import { HomePage } from "./pages/HomePage";
import { MenuPage } from "./pages/MenuPage";
import { InfoPage } from "./pages/InfoPage";

function App() {
  return (
    <div className="App min-h-screen bg-[#050505]">
      <BrowserRouter>
        <Navigation />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/menu" element={<MenuPage />} />
          <Route path="/infos" element={<InfoPage />} />
        </Routes>
        <FloatingCallButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
